<template>
  <div class="qualityAuth-checkInfo">
      <z-cell-group inset>
        <z-cell title="认证状态" :value="invalid ? '过期' : '已认证'"></z-cell>
      </z-cell-group>
      <z-cell-group inset class="cellVisible">
        <z-cell v-for="el in infoList" :key="el.value" :title="el.title" :value="el.value" class="noOverFlow">
          <template slot="value">
            <z-tip position="top" custom :show-close=false :offsetLeft=-30>
              <span class="tipEllipsis">{{el.value}}</span>
              <div slot="tip">
                <div class="tips">
                  <span class="tips-text">{{el.value}}</span>
                </div>
              </div>
            </z-tip>
          </template>
        </z-cell>
      </z-cell-group>
      <z-cell-group inset v-if="invalid">
        <z-cell title="经营主体年检" :is-link="false" @click="toRefresh" value="去更新" label="经营信息有更新" value-class="toRefresh"/>
      </z-cell-group>
  </div>
</template>

<script>
import { Cell, CellGroup, Tip } from '@zz-common/zz-ui'
import native from '@zz-common/native-adapter'
import { getbizlicenseinfo } from '../../../api/resourceApi'
import { queryParams } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'QualityAuthCheckInfo',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      authSource: query.authSource || this.$route.query.authSource,
      certificationInfo: {},
      infoMap: {
        frName: '法定代表人',
        creditCode: '社会信用代码',
        bizName: '企业名称'
      }
    }
  },
  computed: {
    infoList() {
      const tempMap = this.infoMap
      return Object.keys(tempMap).map(el => {
        return { title: tempMap[el], value: this.certificationInfo[el] }
      })
    },
    invalid() {
      return this.certificationInfo?.invalid && this.certificationInfo?.invalid != '0'
    }
  },
  methods: {
    getBizLicenseInfo() {
      getbizlicenseinfo({ sourceCode: this.sourceCode, authSource: this.authSource })
        .then((res) => {
          console.log('getbizlicenseinfoRes', res)
          this.certificationInfo = { ...res }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {
        this.getBizLicenseInfo()
      }
    },
    toRefresh() {
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/qualityauth/license?isupdate=1&sourceCode=${this.sourceCode}`,
        needClose: '0'
      })
    }
  },
  components: {
    zCell: Cell,
    'z-cell-group': CellGroup,
    'z-tip': Tip
  },
  created() {
    this.getBizLicenseInfo()
  },
  mounted() {
    native.setTitle({
      title: '认证资料'
    })
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  }
}

</script>
<style lang="less">
  @import 'index.less';
</style>